import { useSelector } from "react-redux";
import { selectClientPortalPayment } from "../../PayNowPageSlice";
import { PaymentProviders } from "services/api/cplapi/CPLAPI";

export const PaymentConfirmationTable: React.FC = () => {
  const clientPortalPayment = useSelector(selectClientPortalPayment);
  let paymentMethod = "";

  switch (clientPortalPayment?.paymentProvider) {
    case PaymentProviders.Blink:
      paymentMethod = "Card";
      break;
    case PaymentProviders.GoCardless:
      paymentMethod = "Instant Bank Payment";
      break;
  }

  return (
    <div className="p-2">
      <div className="row py-2">
        <label className="col-3 fw-bold">Payment Method</label>
        <label className="col-3">{paymentMethod}</label>
      </div>
      {clientPortalPayment?.paymentAmounts!.map((x) => (
        <div className="row py-2" key={x.clientID}>
          <label className="col-6 col-form-label property-column fw-bold fs-6">
            {x.clientAccountNumber + " - " + x.propertyAddress}
          </label>
          <label className="col-6 text-end col-form-label property-column fw-bold fs-6">
            {(+x.paymentAmount!).toGBPString()}
          </label>
        </div>
      ))}
      <hr />
      <div className="row py-2">
        <h3 className="col-6">Total Paid</h3>
        <h3 className="col-6 text-end">
          {clientPortalPayment
            ?.paymentAmounts!.map((x) => +x.paymentAmount!)
            .reduce((sum, x) => sum + x, 0)
            .toGBPString()}
        </h3>
      </div>
    </div>
  );
};
